import { IconProps } from '.';

function BadgeCheck({ color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>BadgeCheck</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M8 0C12.4191 0 16 3.58086 16 8C16 12.4191 12.4191 16 8 16C3.58086 16 0 12.4191 0 8C0 3.58086 3.58086 0 8 0ZM8 1C4.13314 1 1 4.13314 1 8C1 11.8669 4.13314 15 8 15C11.8669 15 15 11.8669 15 8C15 4.13314 11.8669 1 8 1ZM4.96726 7.64693C5.16248 7.45162 5.47906 7.45155 5.67437 7.64676L7.43949 9.41106L10.8376 5.52812C11.0195 5.32031 11.3354 5.29928 11.5432 5.48114C11.751 5.663 11.772 5.97888 11.5902 6.18668L7.84016 10.4717C7.64972 10.6893 7.31495 10.7005 7.11043 10.496L4.96743 8.35404C4.77212 8.15882 4.77205 7.84224 4.96726 7.64693Z" fill={color} />
    </svg>
  );
}

export default BadgeCheck;
